import React from 'react';
import { CheckerProps } from './model';
import { CheckboxChecker } from './components/checkbox';
import { RadioChecker } from './components/radio';

export const Checker = (props: CheckerProps) => {
  return props.variant === 'checkbox' ? <CheckboxChecker {...props} /> : <RadioChecker {...props} />;
};
